import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map, shareReplay, tap} from 'rxjs/operators';
import {FormSchema} from '@shared/widgets/models/schema';
import {FormSchemaStoreService} from './form-schema-store.service';
import {Observable, of} from 'rxjs';


@Injectable()
export class FormService {
  private table = 'suite_schema';
  /** In-flight form schema requests by module id (AC-47). */
  private inflightByModuleId = new Map<string, Observable<FormSchema>>();

  constructor(private httpClient: HttpClient, private formSchemaStoreService: FormSchemaStoreService) {
  }

  public getFormSchemaByName(formName: string, clientStatus?: string): Observable<FormSchema> {
    return this.httpClient.get(`/${this.table}?formName=${formName}&clientStatus=${clientStatus}`)
      .pipe(
        map(
          (formSchema: FormSchema) => {
            return formSchema;
          })
      );
  }

  public getFormSchemaByModuleId(moduleId: string): Observable<FormSchema> {
    const cached = this.formSchemaStoreService.get(moduleId);
    if (cached) {
      return of(cached);
    }

    let inflight = this.inflightByModuleId.get(moduleId);
    if (!inflight) {
      inflight = this.httpClient.get(`/app/schema/${moduleId}`).pipe(
        map((formSchema: FormSchema) => {
          this.formSchemaStoreService.set(formSchema, moduleId);
          return formSchema;
        }),
        tap({
          finalize: () => this.inflightByModuleId.delete(moduleId),
        }),
        shareReplay({ bufferSize: 1, refCount: true }),
      );
      this.inflightByModuleId.set(moduleId, inflight);
    }
    return inflight;
  }

}
